import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";

// export const userReportNews = createAsyncThunk("reportNews", async ({ newsId, data }, { rejectWithValue }) => {
//     try {
//         const response = await axiosInstance.post(`/neighbor_news/report/${newsId}/`, data)
//         const result = response.data;
//         return result
//     } catch (error) {
//         if (error.response) {
//             // The request was made and the server responded with a status code
//             return rejectWithValue(error.response.data);
//         }
//         else if (error.request) {
//             // The request was made but no response was received
//             return rejectWithValue("No response from server");
//         }
//         else {
//             // Something happened in setting up the request that triggered an Error
//             return rejectWithValue(error.message);
//         }
//     }
// });

export const reportPinboardComment = createAsyncThunk("reportPinboardComment", async ({ commentId, data }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_pinboard/comment/${commentId}/report/`, data)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            return rejectWithValue("No response from server");
        }
        else {
            return rejectWithValue(error.message);
        }
    }
});


export const NeighborhoodNewsReportSlice = createSlice({
    name: "NeighborhoodNews",
    initialState: {
        neighborhoodNewsReport: {},
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {

        builder.addCase(reportPinboardComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(reportPinboardComment.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhoodNewsReport = action.payload;
        });
        builder.addCase(reportPinboardComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        // builder.addCase(userReportNews.pending, (state) => {
        //     state.loading = true;
        // });
        // builder.addCase(userReportNews.fulfilled, (state, action) => {
        //     state.loading = false;
        //     state.neighborhoodNewsReport = action.payload;
        // });
        // builder.addCase(userReportNews.rejected, (state, action) => {
        //     state.loading = false;
        //     state.error = action.payload;
        // });

    },
});

export default NeighborhoodNewsReportSlice.reducer;